import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=97f31352&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=97f31352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f31352",
  null
  
)

export default component.exports